<template>
<Row :gutter="12">
  <Col :span="5">
    <stat-menu></stat-menu>
  </Col>
  <Col :span="19">
    <router-view name="statContent"></router-view>
  </Col>
</Row>
</template>

<script>
import StatMenu from '@/components/stat/StatMenu'

export default {
  name: 'stat',
  components: {
    'stat-menu': StatMenu
  }
}
</script>
